/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState, useContext } from 'react';
import {
  Paper,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { Alert, Autocomplete } from '@material-ui/lab';
import { format } from 'date-fns';
import { ButtonVersion } from './styles';
import useStyle from './useStyle';
import { InternalPage } from '../../Layouts';
import { getVersionsCommerceService, getCurrentVersionCommerceService, updateVersionCommerceService } from '../../services';
import { Toaster, Loading } from '../../components';
import VersionTable from './components/DataTable/VersionsTable';
import sortVersions from '../../utils/sortVersions';
import UserContext from '@/contexts/UserContext';

const AppCommerceVersionScreen = () => {
  const { user } = useContext(UserContext);
  const classes = useStyle();
  const chunkSize = 80;
  const [loading, setLoading] = useState(false);
  const [versions, setVersions] = useState([]);
  const [currentVersion, setCurrentVersion] = useState();
  const [selectedVersion, setSelectedVersion] = useState('');
  const [open, setOpen] = useState(false);
  const [alert, setAlert] = useState({ status: false, type: '', message: '' });
  const [totalElementsData, setTotalElementsData] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [currentChunk, setCurrentChunk] = useState(0);

  const handleNext = () => {
    if (versions.length === totalElementsData) return;
    if (
      versions.length < (currentPage + 2) * currentPageSize
    ) {
      setCurrentChunk((oldChunk) => oldChunk + 1);
    }
    setCurrentPage((oldPage) => oldPage + 1);
  };

  const handleNewPageSize = (newPageSize) => {
    setCurrentPageSize(Number(newPageSize));
    setCurrentPage(0);
  };

  const loadData = () => {
    setLoading(true);
    Promise.all([getVersionsCommerceService()])
      .then(([version]) => {
        setVersions(sortVersions(version?.data, true));
        setLoading(false);
        setTotalElementsData(version?.data.length);
      })
      .catch(() => {
        setLoading(false);
        setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error, intente nuevamente.' });
        setCurrentVersion('');
      });
  };

  const loadCurrentVersion = () => {
    setLoading(true);
    getCurrentVersionCommerceService().then((currVersion) => {
      setCurrentVersion(currVersion?.data);
    }).catch((e) => {
      setLoading(false);
      if (e?.response.status !== 404) {
        setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error, intente nuevamente.' });
      } else {
        setCurrentVersion('');
      }
    });
  };

  useEffect(() => {
    loadData();
    loadCurrentVersion();
  }, [currentChunk, chunkSize]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const updateVersion = async () => {
    handleClose();
    updateVersionCommerceService(selectedVersion.id, user.username)
      .then(() => {
        loadData();
        loadCurrentVersion();
      })
      .catch(() => {
        setAlert({ status: true, type: 'error', message: 'Ha ocurrido un error, intente nuevamente.' });
      });
  };

  const alertMessage = () => {
    if (currentVersion) {
      const { version, date_modified: dateModified, updated_by: updatedBy } = currentVersion;
      const date = new Date(dateModified);
      const dateFormated = format(date, 'dd/MM/yyyy H:mm');
      return (
        <Alert severity="info">
          {'Version mínima requerida de App Comercios: '}
          <b>{version}</b>
          {updatedBy && ` actualizada por ${updatedBy} el ${dateFormated}`}
        </Alert>
      );
    }
    return (
      <Alert severity="info">
        {'No hay una version mínima requerida definida '}
      </Alert>
    );
  };

  return (
    <InternalPage loading={loading} error={alert.type === 'error'}>
      <Paper className={classes.paper}>
        {loading
          ? <Loading />
          : (
            <>
              <Grid container spacing={1} className={classes.container}>
                <Grid item xs={12}>
                  <Box mb={1}>
                    {alertMessage()}
                  </Box>
                </Grid>
                <Grid item xs={8}>
                  <Autocomplete
                    disablePortal
                    options={versions}
                    getOptionLabel={(row) => `${row.version} - ${row.title}`}
                    renderInput={(params) => <TextField {...params} label="Seleccionar versión de App Comercios" />}
                    onChange={(event, value) => setSelectedVersion(value)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <ButtonVersion
                    className={!versions.length > 0 && classes.btnReadOnly}
                    disabled={!versions.length > 0}
                    onClick={handleClickOpen}
                  >
                    Actualizar
                  </ButtonVersion>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box mt={2}>
                  {versions.length > 0 ? (
                    <VersionTable
                      versions={versions}
                      onNext={handleNext}
                      onSelectPageSize={handleNewPageSize}
                      loading={loading}
                      totalElementsData={totalElementsData}
                    />
                  ) : (
                    <Alert severity="warning">
                      No hay versiones por mostrar en el momento
                    </Alert>
                  )}
                </Box>
              </Grid>
              <Toaster
                show={alert.status}
                type={alert.type}
                text={alert.message}
                onClose={() => setAlert({ ...alert, status: false })}
              />
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  ¿ Desea actualizar versión de App Comercios?
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Los usuarios solo podrán ingresar a la aplicación
                  </DialogContentText>
                  <DialogContentText id="alert-dialog-description">
                    {'si la version instalada es '}
                    <b>{selectedVersion.version}</b>
                    {' o superior.'}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancelar</Button>
                  <Button onClick={updateVersion} autoFocus>Aceptar</Button>
                </DialogActions>
              </Dialog>
            </>
          )}
      </Paper>
    </InternalPage>
  );
};

export default AppCommerceVersionScreen;
